(ns frontend.react.virtualized.scrollable-grid.header-selection-grid
  (:require
   [ui.util :as uu]))

(defn view
  [args style key]
  (let [{:keys [header-height hover-atom
                all-selection! selected row-count]}
        args
        select-all-disabled? (= row-count 0)]
    [:div
     {:class         "w-[31px] h-full px-2 flex items-center border-b-2 border-r-2 border-l-2 border-t-2 bg-base-light border-solid border-base-light-border-paler cursor-move even cell-selected"
      :key           (str key (rand-int 10000))
      :style         style
      :on-drag-enter (fn [e]
                       (.preventDefault e)
                       (swap! hover-atom assoc-in [:drag :column] nil))
      :on-drop       (fn [e]
                       (.preventDefault e)
                       (.stopPropagation e))
      :on-drag-over  (fn [e]
                       (.preventDefault e)
                       (aset e "dataTransfer" "effectAllowed" "move"))}
     [:div
      {:class-name (when (and (contains? (-> @hover-atom
                                             :drag)
                                         :column)
                              (nil? (-> @hover-atom
                                        :drag
                                        :column)))
                     "drag-over-column ")}
      [:i
       {:class (uu/cm ""
                           (cond
                             (= :all selected) "fas fa-check-square"
                             (empty? selected) "fal fa-square"
                             :else "fal fa-minus-square"))
        :style      {:cursor (when select-all-disabled? "not-allowed")
                     :color  (when select-all-disabled? "#dddddd")}
        :on-click   (fn [e]
                      (when-not select-all-disabled?
                        (all-selection!)))}]]]))
